module.exports = __webpack_public_path__ + "assets/img/34_772_big.ca47fbec.jpg";